type EventName = typeof Name;

export enum MenuTypes {
  AboutMenu = 'about-mega-menu',
  AccountSideMenu = 'account-side-menu',
  BurgerMenu = 'burger-menu',
  FavoritesSideMenu = 'favorites-side-menu',
  JoinMenu = 'join-mega-menu',
  Minibag = 'mini-bag',
  Notifications = 'notifications',
  SearchInput = 'search-input',
  SearchResults = 'search-results',
  VipOrder = 'vip-order',
}

export const Name = 'toggle-menu-flyout';
export const ToggleFavorite: EventName = Name;

export interface Data {
  menuType: MenuTypes;
  shouldOpen?: boolean;
}

export interface Event extends CustomEvent<Data> {
  type: EventName;
}

export default Event;
